import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";

import React from "react";
import { t } from "utilities/localization-utils";

interface CancelButtonProps {
    onCancel: any;
}

const CSS_CLASS_NAME = "c-done-button";

const CancelButton = ({ onCancel }: CancelButtonProps) => {
    return (
        <Button
            size={ButtonSizes.XSmall}
            cssClassName={CSS_CLASS_NAME}
            style={ButtonStyles.Tertiary}
            onClick={onCancel}>
            {t("cancel")}
        </Button>
    );
};

export default CancelButton;
